import script from "./newsInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./newsInfo.vue?vue&type=script&setup=true&lang=js"

import "./newsInfo.vue?vue&type=style&index=0&id=d0db44e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0db44e2"]])

export default __exports__